function equalHeight() {
    $.fn.extend({
        equalHeights: function() {
            var top = 0;
            var row = [];
            var classname = ("equalHeights" + Math.random()).replace(".", "");
            $(this)
                .each(function() {
                    var thistop = $(this).offset().top;
                    if (thistop > top) {
                        $("." + classname).removeClass(classname);
                        top = thistop;
                    }
                    $(this).addClass(classname);
                    $(this).height("auto");
                    var h = Math.max.apply(
                        null,
                        $("." + classname)
                        .map(function() {
                            return $(this).outerHeight();
                        })
                        .get()
                    );
                    $("." + classname).outerHeight(h);
                })
                .removeClass(classname);
        }
    });
    $(".product-display .product-list").equalHeights();
   if($( window ).width() > 767){
    $(".products-type").equalHeights();
     
      }
  	
    setTimeout(function(){ 

      if($( window ).width() > 769){
      $(".shg-category-row .shg-category-col .shg-product").find( "div:first" ).equalHeights();
      $(".shg-category-row .shg-category-col .shg-product").find( "div:first").addClass("image-shogun-wrapper-class");
      }
      if($( window ).width() > 767){
       $(".only-title .search-page .product-list .collection-product-details-wrapper .product-details .left-wrapper").equalHeights();
      }
    }, 3000);
}


function headerAdj() {
    var headerH = $(".header-section").outerHeight();
    $(".main-content").css({
        "margin-top": headerH
    });
    var headerH1 = $(".header").outerHeight();
    $(".shopify-section.global .globalAnnouncement").css({
        "top": headerH1
    });
}
$(document).ready(function() {

  headerAdj();
  equalHeight();
  

  // Footer Link
  $(".footer__primary__node h5").on("click", function () {
    var $this = $(this).closest(".footer__primary__node");
    if ($(window).width() < 768) {
      $this.toggleClass("open-accordion");
      $this.find("ul").stop(true, false).slideToggle();
      $this.siblings(".open-accordion").removeClass("open-accordion").find("ul").stop(true, false).slideUp();
    } else {
      $(".footer__primary__node ul").css("display", "");
      $(".footer__primary__node").removeClass("open-accordion");
    }
  });


  $(".search-icon").click(function(){
    $(".search_container").toggleClass("search-open");
  });
  
  $(".custaddress").click(function(){
  	document.location.href = '/account/addresses';
  });
  
  $(".product-template").parent().removeClass("container");
  
 
  
  $(".item-remove").click(function(){
    var id = $(this).attr("rel");
      
      if($(this).hasClass('movebtn'))
      { 	if(window.id != 0)
            jQuery.post('/cart/change.js', "updates["+ id +"]=0",  $.getJSON('/cart.js', function(cart) {
                                                                                                }).done(function() {
                                                                                                 location.reload(true)
                                                                                              })   );
            else
             jQuery.post('/cart/change.js', "updates["+ id +"]=0",  window.location.href = "/account/login" );
          
      } 
     else 
     { 
       
       
        jQuery.post('/cart/change.js', "updates["+ id +"]=0", 
        $.getJSON('/cart.js', function(cart) {
          }).done(function() {
           location.reload(true)
        })
                    );
     }
    
  	
  }); 
  
  

  $(".show-more").click(function(){
        $("li.less").removeClass("hide");  
    	$(".show-more").hide();
    	$(".show-less").show();
   });
   $(".show-less").click(function(){
        $("li.less").addClass("hide");  
    	$(".show-more").show();
    	$(".show-less").hide();
   });
  

  
  // Popup Window
		var scrollTop = '';
		var newHeight = '100';

		$(window).bind('scroll', function() {
		   scrollTop = $( window ).scrollTop();
		   newHeight = scrollTop + 100;
		});
		
		$('.popup-trigger').click(function(e) {
		event.preventDefault();
  		 e.stopPropagation();
  		 $('body').addClass('popup-open');
		 if(jQuery(window).width() < 767) {
		   //$(this).after( $( ".popup" ) );
		   $('.popup').show().addClass('popup-mobile').css('top', 0);
		   $('html, body').animate({
				scrollTop: $('.popup').offset().top
			}, 500);   
		 } else {
		   $('.popup').removeClass('popup-mobile').css('top', newHeight).toggle();
		 };
		});
		
		$('html').click(function() {
		 $('.popup').hide();
		 $('body').removeClass('popup-open');
		});

		$('.popup-btn-close').click(function(e){
		  $('.popup').hide();
		 $('body').removeClass('popup-open');

		});

		$('.popup').click(function(e){
		  e.stopPropagation();
		});
  
  
  if ($(window).width() < 767) {  	
    $(".swatch").removeAttr("href");

  }
  
  
  $(".account-menu-mobile").click(function(){
  	$(".left-account-menu").slideToggle();
    $(".dropdown-menu-block").toggleClass("dropdown-open");
    
     if($(".dropdown-menu-block").hasClass("dropdown-open")){
         $(".expand-collapse em").text("Collapse");
       }
       else {
         $(".expand-collapse em").text("Expand");
       }
  });
  
  

  
  
  	
  
  
  $(".main_nav_wrapper.sticky_nav").remove();
  $("#mobile_menu").find('a:first').remove();

  
  // Promo Button Click Js
  $('.promo-btn a').click(function(e){
    e.stopPropagation();
    if($('.promo-code-form').hasClass('hide'))
      $('.promo-code-form').removeClass('hide');
  });
  $('body').click(function(){
    $('.promo-code-form').addClass('hide');
  });
  
  $('#productDownload .accordion-item .accordion-header').click(function(){
    if($(this).hasClass('gor-active')){
       $(this).removeClass('gor-active');
       $(this).next('.accordion-item .accordion-content').removeClass('gor-active');
       $(this).next('.accordion-item .accordion-content').addClass('gor-inactive');
    }
    else{
      $(this).addClass('gor-active');
      $(this).next('.accordion-item .accordion-content').addClass('gor-active');
      $(this).next('.accordion-item .accordion-content').removeClass('gor-inactive');
    }
  });
  

  $('.menu-slider.owl-carousel').each(function(){
    
    if($(this).find('.item').length > 0){
  
  $(this).owlCarousel({
    loop:true,
	 autoplay:true,
    autoplayTimeout:2000,
    margin:10,
    nav:true,
    responsiveClass:true,
    items:1,

});
  }
                                         });
                                         
  $('.home-page-product.owl-carousel').owlCarousel({
    loop:true,
//     autoplay:true,
    margin:30,
    nav:true,
    responsiveClass:true,
    items:4,
    autoHeight: false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        768:{
            items:2,
//             nav:false
        },
        960:{
            items:4,
        },
    }
});
  
  $('.product__photos.owl-carousel').owlCarousel({
    loop:true,
//     autoplay:true,
    margin:30,
    nav:true,
    responsiveClass:true,
    items:1,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        768:{
            items:1,
//             nav:false
        },
        960:{
            items:1,
        },
    }
});

 
   $(window).on('load', function(){
     // setTimeout(function(){
  $('.recently-viewed-product.owl-carousel').owlCarousel({
    loop:false,
//     autoplay:true,
    margin:30,
    nav:true,
    responsiveClass:true,
    items:4,
    autoHeight: false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        768:{
            items:2,
//             nav:false
        },
        960:{
            items:4,
        },
    }
});
        // }, 1500);
   });

  
// Footer Link
$(window).resize(function(event) {
  
  equalHeight();
     if ($(window).width() > 767) {
        $(".footer__primary__node ul").css("display", "");
        $(".footer__primary__node").removeClass("open-accordion");
    }
});
  

 
   $('.left-menu-column li').hover(function(){  
    var tab_id = $(this).attr('data-tab');
    $('.left-menu-column li').removeClass('current');
    $('.inner-content-column').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
   
  
  
  
//   --- end 
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  
  if(links[i].id != "resetStores" && links[i].id != "en-selected" && links[i].id != "zh-TW-selected"){
 	
  
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
    }
}